import React from "react";
import Message from "./message/Message";
import { Speech } from "../../../../../model/transcription/types";

type ChatProps = {
    speeches: Speech[],
    onPlayMessage: (id: string) => void
};

const Chat: React.FunctionComponent<ChatProps> = ({speeches, onPlayMessage}) => {
  return (
     <>
        {speeches.map((speech) => {
            return <Message message={speech} onPlayMessage={onPlayMessage} />
        })}
     </>
  );
};

export default Chat;
